module.exports = require("./fur");